import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46789449"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "report-invoices-header",
  class: "row g-4 py-4"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  id: "report-invoices-header-title",
  class: "col-lg-4 d-flex align-items-center"
}, [
  /*#__PURE__*/_createElementVNode("h6", { style: {"color":"var(--cor_texto_1)"} }, "Relatório de Entradas no Estoque")
], -1))
const _hoisted_3 = {
  id: "report-invoices-header-search",
  class: "col-lg-6"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-search",
  style: {"color":"var(--cor_btn_1)"}
}, null, -1))
const _hoisted_5 = { class: "col-lg-2" }
const _hoisted_6 = { class: "card rounded mb-4 p-4" }
const _hoisted_7 = { class: "row g-4" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "col-md-6" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "col-md-6" }
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "col-md-6" }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = { class: "filter-main-form_date-range_block-8c44eadd-7d5d-4e1b-8dfd-315275ce97f2" }
const _hoisted_18 = { class: "col-md-6 d-flex align-items-center justify-content-center" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-filter",
  "aria-hidden": "true",
  style: {"font-size":"1.2rem"}
}, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-2" }, "Filtrar", -1))
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = {
  key: 0,
  id: "box-table-invoices",
  class: "background_1 card"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-info-circle",
  "aria-hidden": "true",
  style: {"color":"var(--cor_texto_1)","cursor":"pointer"}
}, null, -1))
const _hoisted_25 = ["href"]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-download m-0 p-0 text-white" }, null, -1))
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = {
  key: 1,
  class: "btn btn-sm background_btn_1",
  disabled: ""
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-download m-0 p-0 text-white" }, null, -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "100",
  height: "100",
  viewBox: "0 0 100 100",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    opacity: "0.4",
    d: "M35 60H40V25H35C32.2391 25 30 27.2391 30 30V55C30 57.7609 32.2391 60 35 60ZM90 55V30C90 27.2391 87.7609 25 85 25H80V60H85C87.7609 60 90 57.7609 90 55ZM97.5 70H20V12.5C20 11.1187 18.8813 10 17.5 10H2.5C1.11875 10 0 11.1187 0 12.5V17.5C0 18.8813 1.11875 20 2.5 20H10V77.5C10 78.8812 11.1187 80 12.5 80H25.4594C25.1797 80.7859 25 81.6188 25 82.5C25 86.6422 28.3578 90 32.5 90C36.6422 90 40 86.6422 40 82.5C40 81.6188 39.8203 80.7859 39.5406 80H70.4594C70.1797 80.7859 70 81.6188 70 82.5C70 86.6422 73.3578 90 77.5 90C81.6422 90 85 86.6422 85 82.5C85 81.6188 84.8203 80.7859 84.5406 80H97.5C98.8812 80 100 78.8812 100 77.5V72.5C100 71.1188 98.8812 70 97.5 70ZM75 25V17.5C75 13.3578 71.6422 10 67.5 10H52.5C48.3578 10 45 13.3578 45 17.5V60H75V25ZM67.5 25H52.5V17.5H67.5V25Z",
    fill: "white"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M97.5 70H20V12.5C20 11.1187 18.8813 10 17.5 10H2.5C1.11875 10 0 11.1187 0 12.5V17.5C0 18.8813 1.11875 20 2.5 20H10V77.5C10 78.8812 11.1187 80 12.5 80H25.4594C25.1797 80.7859 25 81.6188 25 82.5C25 86.6422 28.3578 90 32.5 90C36.6422 90 40 86.6422 40 82.5C40 81.6188 39.8203 80.7859 39.5406 80H70.4594C70.1797 80.7859 70 81.6188 70 82.5C70 86.6422 73.3578 90 77.5 90C81.6422 90 85 86.6422 85 82.5C85 81.6188 84.8203 80.7859 84.5406 80H97.5C98.8812 80 100 78.8812 100 77.5V72.5C100 71.1188 98.8812 70 97.5 70Z",
    fill: "white"
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_CampBtnGenerateExcel = _resolveComponent("CampBtnGenerateExcel")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!
  const _component_CampTableTh = _resolveComponent("CampTableTh")!
  const _component_CampTableTd = _resolveComponent("CampTableTd")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_CampTable = _resolveComponent("CampTable")!
  const _component_CampEmptyListFeedbackV2 = _resolveComponent("CampEmptyListFeedbackV2")!
  const _component_CampFooterPaginationControl = _resolveComponent("CampFooterPaginationControl")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_input, {
          modelValue: _ctx.keywordSearch,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.keywordSearch) = $event)),
          placeholder: "Filtre por palavra chave...",
          type: "text",
          disabled: !(!_ctx.isLoading && Array.isArray(_ctx.reportInvoicesTableRender) && _ctx.reportInvoicesTableRender.length > 0) && _ctx.keywordSearch.length < 1
        }, null, 8, ["modelValue", "disabled"]),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_CampBtnGenerateExcel, {
          "table-data": Array.isArray(_ctx.reportInvoicesTableRender) && _ctx.reportInvoicesTableRender.map(el => ({ ...el, XMLFileURL: el.XMLFileURL?.split('/').pop() })) || [],
          label: "Exportar",
          "file-name": "Relatório de Entradas no Estoque",
          "renamed-column-list": [
            `companyCNPJ as ${_ctx.COLS_TABLE.companyCNPJ}`,
            `companyName as ${_ctx.COLS_TABLE.companyName}`,
            `storeName as ${_ctx.COLS_TABLE.storeName}`,
            `storeCNPJ as ${_ctx.COLS_TABLE.storeCNPJ}`,
            `userResponsible as ${_ctx.COLS_TABLE.userResponsible}`,
            `type as ${_ctx.COLS_TABLE.type}`,
            `movementId as ${_ctx.COLS_TABLE.movementId}`,
            `created_at as ${_ctx.COLS_TABLE.created_at}`,
            `desc as ${_ctx.COLS_TABLE.desc}`,
            `sku as ${_ctx.COLS_TABLE.sku}`,
            `cod as ${_ctx.COLS_TABLE.cod}`,
            `qtd as ${_ctx.COLS_TABLE.qtd}`,
            `XMLFileURL as ${_ctx.COLS_TABLE.XMLFileURL}`,
            `ps as ${_ctx.COLS_TABLE.ps}`,
            `valor as ${_ctx.COLS_TABLE.valor}`,
          ],
          "hidden-column-list": ['tableId'],
          "btn-class": "btn_background_1 btn-sm"
        }, null, 8, ["table-data", "renamed-column-list"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_select, {
            modelValue: _ctx.searchFields.company,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchFields.company) = $event)),
            multiple: "",
            filterable: "",
            "collapse-tags": "",
            placeholder: "Companhias...",
            clearable: "",
            class: "w-100",
            disabled: !(Array.isArray(_ctx.companyList))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companyList, (el) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: el.id,
                  value: el.id,
                  label: el.option
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(el.option), 1)
                  ]),
                  _: 2
                }, 1032, ["value", "label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_select, {
            modelValue: _ctx.searchFields.store,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchFields.store) = $event)),
            multiple: "",
            filterable: "",
            "collapse-tags": "",
            placeholder: "Lojas...",
            clearable: "",
            class: "w-100",
            disabled: !(Array.isArray(_ctx.storeList))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storeList, (el) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: el.id,
                  value: el.id,
                  label: el.option
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(el.option), 1)
                  ]),
                  _: 2
                }, 1032, ["value", "label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_select, {
            modelValue: _ctx.searchFields.user,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchFields.user) = $event)),
            multiple: "",
            filterable: "",
            "collapse-tags": "",
            placeholder: "Usuários...",
            clearable: "",
            class: "w-100",
            disabled: !(Array.isArray(_ctx.userList))
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userList, (el) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: el.id,
                  value: el.id,
                  label: el.option
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(el.option), 1)
                  ]),
                  _: 2
                }, 1032, ["value", "label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue", "disabled"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.searchFields.movementId,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchFields.movementId) = $event)),
            placeholder: "Nº da Nota Fiscal...",
            clearable: "",
            type: "text",
            class: "w-100"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(_component_el_input, {
            modelValue: _ctx.searchFields.ps,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchFields.ps) = $event)),
            placeholder: "Observação...",
            clearable: "",
            type: "text",
            class: "w-100"
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_el_select, {
            modelValue: _ctx.searchFields.operationType,
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.searchFields.operationType) = $event)),
            multiple: "",
            filterable: "",
            "collapse-tags": "",
            placeholder: "Tipo da Operação...",
            clearable: "",
            class: "w-100"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.OPERATION_TYPE_LIST, (el) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: el.key,
                  value: el.key,
                  label: el.label
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(el.label), 1)
                  ]),
                  _: 2
                }, 1032, ["value", "label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_el_select, {
            modelValue: _ctx.searchFields.feedback,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.searchFields.feedback) = $event)),
            filterable: "",
            "collapse-tags": "",
            placeholder: "Mensagem de retorno...",
            clearable: "",
            class: "w-100"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.FEEDBACK_LIST, (el) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: el.key,
                  value: el.key,
                  label: el.label
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(el.label), 1)
                  ]),
                  _: 2
                }, 1032, ["value", "label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_el_select, {
            modelValue: _ctx.searchFields.oldest,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.searchFields.oldest) = $event)),
            filterable: "",
            "collapse-tags": "",
            placeholder: "Ordenação",
            clearable: "",
            class: "w-100"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.OLDEST_LIST, (el) => {
                return (_openBlock(), _createBlock(_component_el_option, {
                  key: el.key,
                  value: el.key,
                  label: el.label
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", null, _toDisplayString(el.label), 1)
                  ]),
                  _: 2
                }, 1032, ["value", "label"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createVNode(_component_el_config_provider, {
              locale: _ctx.ptBr,
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  id: "filter-main-form_remittance-date-range",
                  type: "daterange",
                  "range-separator": "-",
                  "start-placeholder": "Início",
                  "end-placeholder": "Fim",
                  format: "DD/MM/YYYY",
                  modelValue: _ctx.searchFields.date,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.searchFields.date) = $event)),
                  style: {"width":"100%"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["locale"])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("button", {
            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleSearch())),
            class: "btn btn-sm w-100 h-100 background_btn_1_opct"
          }, _hoisted_21)
        ])
      ])
    ]),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          (Array.isArray(_ctx.reportInvoicesTableRender) && _ctx.reportInvoicesTableRender.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createVNode(_component_CampTable, { class: "mb-0 mt-0" }, {
                  default: _withCtx(() => [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createVNode(_component_CampTableTh, { class: "py-4 text-center" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.COLS_TABLE.companyName), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_CampTableTh, { class: "py-4 text-center" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.COLS_TABLE.companyCNPJ), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_CampTableTh, { class: "py-4 text-center" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.COLS_TABLE.storeName), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_CampTableTh, { class: "py-4 text-center" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.COLS_TABLE.storeCNPJ), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_CampTableTh, { class: "py-4 text-center" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.COLS_TABLE.userResponsible), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_CampTableTh, { class: "py-4 text-center" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.COLS_TABLE.type), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_CampTableTh, { class: "py-4 text-center" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.COLS_TABLE.movementId), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_CampTableTh, { class: "py-4 text-center" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.COLS_TABLE.created_at), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_CampTableTh, { class: "py-4 text-center" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.COLS_TABLE.desc), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_CampTableTh, { class: "py-4 text-center" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.COLS_TABLE.sku), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_CampTableTh, { class: "py-4 text-center" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.COLS_TABLE.cod), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_CampTableTh, { class: "py-4 text-center" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.COLS_TABLE.qtd), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_CampTableTh, { class: "py-4 text-center" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.COLS_TABLE.valor), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_CampTableTh, { class: "py-4 text-center" }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.COLS_TABLE.ps), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_CampTableTh, { class: "py-4 text-center" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Ações")
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.reportInvoicesTableRender, (report) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: report.tableId
                        }, [
                          _createVNode(_component_CampTableTd, { class: "py-4" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(report.companyName), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_CampTableTd, { class: "py-4 text-center" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.campHandleCNPJ(report.companyCNPJ, "formatted") || '-'), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_CampTableTd, { class: "py-4" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(report.storeName), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_CampTableTd, { class: "py-4 text-center" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.campHandleCNPJ(report.storeCNPJ, "formatted") || '-'), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_CampTableTd, { class: "py-4 text-center" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(report.userResponsible), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_CampTableTd, { class: "py-4 text-center" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(report.type), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_CampTableTd, { class: "py-4 text-center" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(report.movementId), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_CampTableTd, { class: "py-4 text-center" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(report.created_at), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_CampTableTd, { class: "py-4" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(report.desc), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_CampTableTd, { class: "py-4 text-center" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(report.sku), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_CampTableTd, { class: "py-4 text-center" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(report.cod), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_CampTableTd, { class: "py-4 text-center" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(report.qtd), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_CampTableTd, { class: "py-4 text-center" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.formatCurrency(report.valor)), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_CampTableTd, {
                            class: _normalizeClass(`${report.ps ? 'py-4' : 'py-4 text-center' }`)
                          }, {
                            default: _withCtx(() => [
                              (report.ps && report.ps.length > 35)
                                ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                    key: 0,
                                    class: "item",
                                    effect: "dark",
                                    placement: "bottom"
                                  }, {
                                    content: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(report.ps), 1)
                                    ]),
                                    default: _withCtx(() => [
                                      _hoisted_24
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              _createTextVNode(" " + _toDisplayString(report.ps && `${report.ps.length >= 35 ? `${_ctx.campRemoveLastNonAlphanumericCharacters(report.ps, 35, '...')}` : report.ps}` || '-'), 1)
                            ]),
                            _: 2
                          }, 1032, ["class"]),
                          _createVNode(_component_CampTableTd, { class: "py-4 text-center" }, {
                            default: _withCtx(() => [
                              (!!report.XMLFileURL && report.XMLFileURL.includes('http'))
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: "btn btn-sm background_btn_1",
                                    href: `${report.XMLFileURL}`,
                                    target: "_blank"
                                  }, _hoisted_27, 8, _hoisted_25))
                                : (_openBlock(), _createElementBlock("button", _hoisted_28, _hoisted_30))
                            ]),
                            _: 2
                          }, 1024)
                        ]))
                      }), 128))
                    ])
                  ]),
                  _: 1
                })
              ]))
            : (_openBlock(), _createBlock(_component_CampEmptyListFeedbackV2, {
                key: 1,
                id: "log-icon-empty-list-feedback"
              }, {
                icon: _withCtx(() => [
                  _hoisted_31
                ]),
                message: _withCtx(() => [
                  _createTextVNode(" Não existem registros de operações para este filtro! ")
                ]),
                _: 1
              })),
          _createVNode(_component_CampFooterPaginationControl, {
            class: "mt-5 mb-20",
            index: _ctx.indexCurrentPage,
            total: _ctx.totalPage,
            "onGet:UpdatedPageID": _cache[11] || (_cache[11] = (ID) => _ctx.handlePaginationRendering(ID))
          }, null, 8, ["index", "total"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_el_skeleton, {
          key: 1,
          rows: 5
        }))
      : _createCommentVNode("", true)
  ]))
}